import { STRIPE_PAYMENT_METHODS } from 'components/PaymentMethodSelector/PaymentMethodSelector.constants';

export const paymentMethodRequiresRedirect = paymentMethod => {
  const shouldRedirect = [STRIPE_PAYMENT_METHODS.IDEAL, STRIPE_PAYMENT_METHODS.SOFORT].includes(paymentMethod);

  return shouldRedirect;
};
